import { render, staticRenderFns } from "./HelpCollapse.vue?vue&type=template&id=6d54126e&scoped=true"
import script from "./HelpCollapse.vue?vue&type=script&lang=js"
export * from "./HelpCollapse.vue?vue&type=script&lang=js"
import style0 from "./HelpCollapse.vue?vue&type=style&index=0&id=6d54126e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d54126e",
  null
  
)

export default component.exports